import { ValidationType } from '../../../../common/ValidationType';
import { tenYearsAfter } from '../../../../common/DateHelper/DateHelper';

export const TRAVEL_SERVICE_DETAILS = 'Travel Services Details';
export const ADD_SERVICE = 'Add-Service';
export const TRAVEL_SERVICE = 'Travel Service';

const PREF_TRAVEL_METHOD = 'Preferred Mode of Travel';
const TRAVEL_PURPOSE = 'Travel Purpose';
const DEPARTURE_LOCATION = 'Departure_Location';
const DEPARTURE_DATE = 'Departure Date';
const DEPARTURE_TIME = 'Departure Time';
const ARRIVAL_LOCATION = 'Arrival Location';
const ARRIVAL_DATE = 'Arrival Date';
const ARRIVAL_TIME = 'Arrival Time';

export const TRAVEL_SERVIDE_INFO = [
    {
        name: PREF_TRAVEL_METHOD,
        type: 'dropdown',
        value: '',
        validation: true,
        isRequired: true,
        valid: true,
        modified: false,
        needValidation: true,
        validationType: [
            { type: ValidationType.IsRequired },
            { type: ValidationType.ValidTravelMode },
        ]
    },
    {
        name: TRAVEL_PURPOSE,
        type: 'dropdown',
        value: '',
        validation: true,
        isRequired: true,
        needValidation: true,
        valid: true,
        modified: false,
        validationType: [
            { type: ValidationType.IsRequired },
            { type: ValidationType.ValidId },
        ]
    },
    {
        name: DEPARTURE_LOCATION,
        type: 'input',
        value: '',
        validation: true,
        isRequired: true,
        valid: true,
        needValidation: true,
        modified: false,
        validationType: [
            { type: ValidationType.IsRequired },
        ]
    },
    {
        name: DEPARTURE_DATE,
        type: 'calendar',
        value: '',
        validation: true,
        isRequired: true,
        valid: true,
        needValidation: true,
        modified: false,
        minDate: new Date(),
        maxDate: tenYearsAfter(),
        smallCalendar: true,
        validationType: [
            { type: ValidationType.IsRequired },
            { type: ValidationType.ValidDate },
        ]
    },
    {
        name: DEPARTURE_TIME,
        type: 'time',
        value: '',
        validation: true,
        valid: true,
        modified: false,
        isAm: '',
        needValidation: true,
        validationType: [
            { type: ValidationType.ValidTime },
        ]
    },
    {
        name: ARRIVAL_LOCATION,
        type: 'input',
        value: '',
        validation: true,
        needValidation: true,
        isRequired: true,
        valid: true,
        modified: false,
        validationType: [
            { type: ValidationType.IsRequired },
        ]
    },
    {
        name: ARRIVAL_DATE,
        type: 'calendar',
        value: '',
        validation: true,
        needValidation: true,
        isRequired: true,
        valid: true,
        minDate: new Date(),
        maxDate: tenYearsAfter(),
        smallCalendar: true,
        validationType: [
            { type: ValidationType.IsRequired },
            { type: ValidationType.ValidDate },
        ]
    },
    {
        name: ARRIVAL_TIME,
        type: 'time',
        value: '',
        validation: true,
        valid: true,
        modified: false,
        isAm: '',
        needValidation: true,
        validationType: [
            { type: ValidationType.ValidTime },
        ]
    },
]

export const PASSENGER_DETAILS = 'Passenger Details';
const PASSENGER_NAME = 'Passenger Name';
const RELATIONSHIP = 'Relationship';
const FREQUENT_FLYER_NO = 'Frequent Flyer No.';
const DIETARY_REQUIREMENT = 'Dietary Requirement';
const EXCESS_BAGGAGE = 'Excess Baggage';
export const ADD_PASSENGER = 'Add-Passenger';

export const PASSENGER_DETAILS_INFO = [
    {
        name: PASSENGER_NAME,
        type: 'dropdown',
        value: '',
        validation: true,
        isRequired: true,
        valid: true,
        modified: false,
        needValidation: true,
        validationType: [
            { type: ValidationType.IsRequired },
            { type: ValidationType.ValidId },
        ]
    },
    {
        name: RELATIONSHIP,
        type: 'input',
        value: '',
        validation: true,
        valid: true,
        modified: false,
        readOnly: true,
    },
    {
        name: FREQUENT_FLYER_NO,
        type: 'input',
        value: '',
        validation: true,
        valid: true,
        modified: false,
        validationType: [
            { type: ValidationType.IsRequired },
        ]
    },
    {
        name: DIETARY_REQUIREMENT,
        type: 'dropdown',
        value: '',
        validation: true,
        valid: true,
        modified: false,
        validationType: [
            { type: ValidationType.IsRequired },
        ]
    },
    {
        name: EXCESS_BAGGAGE,
        type: 'input',
        value: '',
        validation: true,
        valid: true,
        modified: false,
        validationType: [
            { type: ValidationType.IsRequired },
        ]
    }
]